<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
        color="blue accent-3"
        dark
        extended
        flat
        class="toolbar__fixed"
      >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex grow>
                <h3>Přehled smluv Troyské Unce</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mt-3" align-center>
              <v-flex xs12 sm2>
                <v-text-field
                  label="Hledat dle jména"
                  class="mx-2"
                  v-model="search"
                  clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm2>
                <v-text-field
                  label="Hledat dle čísla smlouvy"
                  class="mx-2"
                  v-model="smlouva_search"
                  clearable
                ></v-text-field>
              </v-flex>
            </v-layout>
            <div class="table-border__radius">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50]"
              >
                <template slot="items" slot-scope="props">
                  <td v-if="props.item">
                    {{ props.item.cislo_smlouvy }}
                    <br>
                    <span
                        v-if="props.item.portfolio.rozesporeny_slitek != null">
                      {{ props.item.portfolio.rozesporeny_slitek.sl_kod }}: {{ props.item.portfolio.rozesporeny_slitek.g_aktual }} gramů
                      <br>
                      celkem: {{ props.item.portfolio.rozesporeny_slitek.g_total }} gramů (tj. {{ props.item.portfolio.rozesporeny_slitek.sl_koupeno }}/{{ props.item.portfolio.rozesporeny_slitek.sl_pocet }})
                      <br>
                      předáno: {{ props.item.portfolio.evidence_slitku.length }}
                      <br>
                      investováno: {{ props.item.portfolio.investice }}
                    </span>
                  </td>
                  <td>
                    {{ props.item.nazev_osoby }}
                    <br>
                    {{ props.item.id }}
                  </td>
                  <td>
                    <div v-if="props.item.com_klient && props.item.com_klient.id !== undefined">
                      {{ props.item.com_klient.jmeno }} {{ props.item.com_klient.prijmeni }}
                      <br>
                      {{ props.item.com_klient.id }}
                    </div>
                    <div v-else>
                      <span v-if="props.item.com_klient.search_count > 1">
                        Klienta jsme nedokázali identifikovat ({{ props.item.com_klient.search_count }} nálezů)
                      </span>                      <span v-else>
                        Migrovat nejprve klienta do COMu.
                        <v-btn color="primary" class="elevation-0" @click="migrovatOsobu(props.item)">Migrovat osobu</v-btn>
                      </span>
                    </div>
                  </td>

                  <td>
                    <span
                      v-if="props.item.tu_poradce != null">
                    {{ props.item.tu_poradce.jmeno }} {{ props.item.tu_poradce.prijmeni }}
                    <br>
                    {{ props.item.tu_poradce.id }}
                    </span>
                    <span
                      v-else>
                      Poradce TU neidentifikován.
                    </span>
                  </td>
                  <td>
                    <span
                      v-if="props.item.com_poradce != null">
                    {{ props.item.com_poradce.jmeno }} {{ props.item.com_poradce.prijmeni }}
                    <br>
                    {{ props.item.com_poradce.id }}
                    </span>
                    <span
                      v-else-if="props.item.tu_poradce.search_count === 1">
                      Poradce COM neidentifikován.
                      <v-btn v-if="props.item.tu_poradce.search_count === 1" color="primary" class="elevation-0" @click="migrovatPoradce(props.item)">Migrovat poradce</v-btn>
                    </span>
                    <span
                      v-else>
                      Poradce jsme nedokázali identifikovat ({{ props.item.tu_poradce.search_count }} nálezů)
                    </span>
                  </td>
                  <td>
                    {{ props.item.datum_prevedeni }}
                    <template v-for="varovani in props.item.varovani">
                      <br><span class="red--text">{{ varovani }}</span>
                    </template>
                  </td>
                  <td class="text-center">

                    <v-btn color="primary" class="elevation-0" @click="migrovatSmlouvu(props.item)" v-if="props.item.prevedene_sporeni === null" :disabled="props.item.varovani != ''">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Migrovat smlouvu</v-btn>

                    <router-link :to="{ path: '/klienti/' + props.item.com_klient.id + '/sporici-programy/' + props.item.prevedene_sporeni }" target="_blank" color="blue darken-3" class="ma-0 mb-3 elevation-0" v-if="props.item.prevedene_sporeni !== null">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Zobrazit spoření
                    </router-link>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      updateItem: {},
      headers: [
        { text: 'Číslo smlouvy (+slitek)', value: 'cislo_smlouvy' },
        { text: 'Klient v TU', value: 'id' },
        { text: 'Klient v COMu', value: 'nazev_osoby' },
        { text: 'Poradce v TU', value: 'id' },
        { text: 'Poradce v COMu', value: 'nazev_osoby' },
        { text: 'Datum/Upozornění', value: 'nazev_osoby' },
        { text: 'Akce', value: 'cislo_smlouvy' },
      ],
      items: [],
      loadingTable: true,
      search: "",
      smlouva_search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: "cislo_smlouvy",
        totalItems: 0
      },
      valid: true,
      // Dialog create end
      // Rules start
    }
  },
  watch: {
    search () {
      this.queryList();
    },
    smlouva_search () {
      this.queryList();
    },
    pagination: {
      handler: function(newValue) {
        if (!this.loadingTable)
          this.load();
      },
      deep: true
    },
  },
  computed: {
    api_url_admin () {
      return window.api.$api_url;
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    migrovatOsobu: function (item) {
      window.API.post("tu/migrace-osoby", {
        cislo_smlouvy: item.cislo_smlouvy
      }).then(function () {this.load()}.bind(this));
    },
    migrovatPoradce: function (item) {
      window.API.post("tu/migrace-poradce", {
        cislo_smlouvy: item.cislo_smlouvy
      }).then(function () {this.load()}.bind(this));
    },
    migrovatSmlouvu: function (item) {
      window.API.post("tu/migrace-smlouvy", {
        cislo_smlouvy: item.cislo_smlouvy
      }).then(function () {this.load()}.bind(this));
    },
    load: function() {
      console.log('loaduju');
      this.counter++;
      console.log('counterplus');
      this.loadingTable = true;
      window.API.post("tu/search", {
        pagination: this.pagination,
        s: this.search,
        smlouva: this.smlouva_search,
        echo: this.counter,
      }).then(function(body) {
        if (this.counter !== body.echo) {
          console.log('bodyreturn');
          return;
        }
        console.log('budereplace');
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
        console.log('bylreplace');
      }.bind(this)).catch(function(err) {
        console.log('bude error');
        console.log(err);
      }.bind(this));
    },
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TestTools/MigraceTroyskaUnce.vue